import React from 'react';
import styled from 'styled-components';
import { spacer40, spacer48 } from '@spotify-internal/encore-foundation';
import { Card } from './Card';
import { logger } from '../../../lib/Api';
import wrappedCardImageDefault from './assets/wrapped-homecard-en.png';
// import wrappedCardImageBr from './assets/wrapped-homecard-br.png';
// import wrappedCardImageDe from './assets/wrapped-homecard-de.png';
// import wrappedCardImageMx from './assets/wrapped-homecard-mx.png';
import { defineMessage, useIntl } from 'react-intl';
import { WRAPPED_BUTTON_COLOR_DEFAULT } from '../../Podcast/utils/wrapped';
import { LOCALE_PREFERENCES } from '../../../lib/constants';

const LOCALE_IMAGES = {
  // br: wrappedCardImageBr,
  // de: wrappedCardImageDe,
  // mx: wrappedCardImageMx,
};

export function WrappedCard() {
  const intl = useIntl();
  const { formatMessage, locale } = intl;
  const titleMsg = defineMessage({
    id: 'home.wrapped-title',
    defaultMessage: 'It’s here!',
  });
  const descriptionMsg = defineMessage({
    id: 'home.wrapped-description',
    defaultMessage:
      'Take a look back at your year in podcasting—the standout moments, numbers, and more.',
  });
  const buttonTextMsg = defineMessage({
    id: 'home.wrapped-button',
    defaultMessage: 'Get your Wrapped',
  });
  const title = formatMessage(titleMsg);
  const description = formatMessage(descriptionMsg);
  const buttonText = formatMessage(buttonTextMsg);
  function logClick() {
    logger.wrappedCardClick();
  }
  const normalizedLocale = LOCALE_PREFERENCES[locale]
    ? LOCALE_PREFERENCES[locale].languageCode
    : 'us';
  const imageUrl = LOCALE_IMAGES[normalizedLocale] || wrappedCardImageDefault;
  return (
    <WrappedContainer>
      <Card
        imageUrl={imageUrl}
        href="/catalog"
        title={title}
        titleColor={WRAPPED_BUTTON_COLOR_DEFAULT}
        description={description}
        callToAction={{ external: false, text: buttonText }}
        onClick={logClick}
        isDarkBackground
      />
    </WrappedContainer>
  );
}

const WrappedContainer = styled.div`
  grid-area: wrapped;
  margin: ${spacer48} 0 ${spacer40};
`;
